<template>
    <div class="group/entry py-1 px-2"
        :class="[
            index > 0 ? 'border-t border-gray-300' : '',
            show_dropdown ? 'bg-gray-100' : 'hover:bg-blue-50',
        ]"
        @click.stop="handleRowClick"
        @click.right.prevent.stop="handleRowClick"
    >
        <div class="group/entry flex flex-col md:flex-row items-start md:items-center justify-between">
            <div class="flex flex-1 items-center leading-snug pr-6 pt-1 pb-0.5"
                :class="[
                    show_dropdown ? 'bg-transparent' : '',
                ]"
            >
                <!-- Selection checkbox -->
                <div v-if="selection_mode" class="flex items-center mr-3 mb-0.5">
                    <input
                        type="checkbox"
                        :checked="is_selected"
                        @click.stop="handleCheckboxClick"
                        @click.right.prevent.stop="handleCheckboxClick"
                        class="w-4 h-4"

                    />
                </div>

                <span class="flex items-start mr-4 group-hover/entry:text-blue-600"
                    :class="show_dropdown ? 'text-blue-600' : 'text-black group-hover/entry:text-blue-600'"
                >
                    <file-text-icon v-if="is_editable" size="14" class="inline mr-2 mt-0.5" />

                    <div class="font-semibold text-base leading-snug select-none">
                        {{ template.display_name || template.name }}
                    </div>
                </span>
            </div>

            <div class="flex items-center text-gray-600 group-hover/entry:text-blue-500">
                <div v-if="!disable_contextual_menus" class="hidden group-hover/entry:flex items-center justify-center w-6 h-6 rounded-full">
                    <more-horizontal-icon size="16" />
                </div>
            </div>
        </div>

        <contextual-dropdown
            v-if="!disable_contextual_menus"
            :show="show_dropdown"
            :items="dropdown_items"
            :x="dropdownX"
            :y="dropdownY"
            @item-clicked="handleDropdownAction"
            @close="closeDropdown"
        />
    </div>
</template>

<script>
import { FileTextIcon, MoreHorizontalIcon } from 'vue-feather-icons';
import ContextualDropdown from '../../components/contextual-dropdown.vue';

export default {
    components: {
        ContextualDropdown,
        FileTextIcon,
        MoreHorizontalIcon,
    },

    props: {
        template: {},
        index: {},
        selection_mode: { default: false },
        selected_documents: { default: () => [] },
        disable_contextual_menus: { default: false },
        is_editable: { default: true },
    },

    data() {
        return {
            show_dropdown: false,
            dropdownX: 0,
            dropdownY: 0,
        }
    },

    computed: {
        selected_template_ids() {
            return this.selected_documents
                .filter(document => document.type === 'template')
                .map(document => document.id);
        },
        is_selected() {
            return this.selected_template_ids.includes(this.template.id);
        },
        dropdown_items() {
            const items = [];

            if (this.template.download_route) {
                items.push({
                    key: 'download',
                    label: 'Download',
                    icon: 'far fa-arrow-alt-circle-down',
                    action: 'download',
                    href: this.template.download_route,
                });
            }

            if (this.template.show_route) {
                items.push({
                    key: 'preview',
                    label: 'Preview',
                    icon: 'far fa-eye',
                    action: 'preview',
                    href: this.template.show_route,
                    target: '_blank',
                });
            }

            // Add to envelope option (no-op for now)
            // items.push({
            //     key: 'add-to-envelope',
            //     label: 'Add this Form to an Envelope',
            //     icon: 'far fa-envelope',
            //     action: 'add-to-envelope',
            // });

            return items;
        }
    },

    methods: {
        handleCheckboxClick(event) {
            this.toggleSelection();
        },
        handleRowClick(event) {
            if (this.selection_mode) {
                this.toggleSelection();
                return;
            }

            this.dropdownX = event.clientX;
            this.dropdownY = event.clientY;
            this.openDropdown();
        },
        closeDropdown() {
            this.show_dropdown = false;
        },
        openDropdown() {
            this.show_dropdown = true;
        },
        handleDropdownAction(item) {
            switch (item.action) {
                case 'preview':
                    if (item.href) {
                        window.open(item.href, '_blank');
                    }
                    break;
                case 'download':
                    if (item.href) {
                        window.location.href = item.href;
                    }
                    break;
                case 'add-to-envelope':
                    // No-op for now
                    console.log('Add to envelope:', this.template.name);
                    break;
            }
        },
        toggleSelection() {
            const new_selected_documents = [...this.selected_documents];
            const index = new_selected_documents.findIndex(d => d.type === 'template' && d.id === this.template.id);
            
            if (index > -1) {
                new_selected_documents.splice(index, 1);
            } else {
                new_selected_documents.push({
                    id: this.template.id,
                    folder_id: this.template.folder_id,
                    display_filename: this.template.display_name,
                    order: null,
                    type: 'template',
                });
            }

            this.$emit('selection-changed', new_selected_documents);
        },
    },
}
</script>
